export const teamMixins = {
  methods: {
    allTeams () {
      this.$http.get('/teams')
        .then(response => this.showTeams(response))
        .catch((e) => this.error(e))
    },

    showTeams (response) {
      this.teams = response.data
    },

    selectTeam (id) {
      var t = this.teams.find(function (t) {
        return t.id === id
      })
      this.setTeam(t)
    },

    getTeam (id) {
      this.$http.get('/teams/' + id)
        .then(response => this.setTeam(response.data))
        .catch((e) => this.error(e))
    },

    setTeam (t) {
      this.team = t
    },

    resetTeam (id) {
      if (typeof id !== 'undefined') {
        this.getTeam(id)
      } else {
        this.setBlankTeam()
      }
    },

    setBlankTeam () {
      this.team = {
        name: ''
      }
    },

    createSuccessful (response) {
      this.setTeam(response.data)
      var id = response.data.id
      this.$router.push('/admin/teams' + id)
    },

    error (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/teamMixins.js